import styled from 'styled-components'

export const StyledPrivacyPolicyContainer = styled.div`
  @media screen and (max-width: 600px) {
    padding: 1rem !important;
  }
`
